import { render, staticRenderFns } from "./SendMailAddAttachment.vue?vue&type=template&id=44f97aa4&"
import script from "./SendMailAddAttachment.vue?vue&type=script&lang=js&"
export * from "./SendMailAddAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports